import Cookies from 'js-cookie';

export const LINK_VTB_LIFE = 'https://www.vtblife.ru/';
export const AUTH_APP_NAME = 'auth';
export const CRM_CALLS_WIDGET_APP_NAME = 'crm-calls-widget';
export const CHAT_APP_NAME = 'chat';
export const IS_WEBVIEW_CLIENT = Cookies.get('is_webview_client') === 'true';
